module.exports = __webpack_public_path__ + "static/media/caret-circle-up.fc244048.svg";